import React, { useState } from "react";
import Ideadox from "../../logos/Ideadox.svg";
import { useNavigate } from "react-router-dom";
import Typography from "@mui/material/Typography";
import Star from "../../logos/Star.svg";
import { caseStudies } from "../CaseStudy";
import CaseStudyCard from "../CaseStudyCard";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";
import MenuIcon from "@mui/icons-material/Menu";
import { isMobile } from "react-device-detect";

const CaseStudy8 = () => {
  const navigate = useNavigate();

  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const displayedCaseStudies = caseStudies.slice(0, 3);

  return (
    <div
      style={{
        backgroundColor: "#F0DFD8",
        padding: "2rem",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        overflowX: "hidden",
        overflow: "hidden",
      }}
    >
      <header
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          padding: "1rem",
          boxSizing: "border-box",
          top: 5,
          position: "absolute",
        }}
      >
        <div
          onClick={() => navigate("/caseStudy")}
          style={{ cursor: "pointer" }}
        >
          <img src={Ideadox} alt="Ideadox" />
        </div>
        {isMobile ? (
          <div>
            <Button
              className="border border-black mt-2 rounded-full"
              onClick={handleMenuOpen}
            >
              <MenuIcon />
            </Button>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
              sx={{
                "& .MuiPaper-root": {
                  backgroundColor: "rgba(255, 255, 255, 0.8)", // Semi-transparent white
                  boxShadow: "none",
                },
              }}
            >
              <MenuItem
                onClick={handleMenuClose}
                style={{
                  color: "#000",
                  fontFamily: "Golos Text",
                }}
              >
                Blog
              </MenuItem>
              <MenuItem
                onClick={() => navigate("/caseStudy")}
                style={{
                  color: "#000",
                  fontFamily: "Golos Text",
                }}
              >
                Case Study
              </MenuItem>
              <MenuItem
                onClick={() => navigate("/aboutus")}
                style={{
                  color: "#000",
                  fontFamily: "Golos Text",
                }}
              >
                About
              </MenuItem>
            </Menu>
            <button className="border border-black py-1 px-2 mt-2 rounded-full hover:bg-black hover:text-white">
              Get In Touch
            </button>
          </div>
        ) : (
          <nav className="space-x-4 mr-4">
            <button
              className="hover:underline"
              onClick={() => {
                /* handle click */
              }}
            >
              Blog
            </button>
            <button
              className="hover:underline"
              onClick={() => {
                navigate("/caseStudy");
              }}
            >
              Case Study
            </button>
            <button
              className="hover:underline"
              onClick={() => navigate("/aboutus")}
            >
              About
            </button>
            <button className="border border-black py-1 px-3 rounded-full hover:bg-black hover:text-white">
              Get In Touch
            </button>
          </nav>
        )}
      </header>
      <Typography
        style={{
          fontFamily: "Bricolage Grotesque",
          fontWeight: 600,
          fontSize: isMobile ? "24px" : "48px", // Adjust font size for mobile
          color: "#2F2F30",
          lineHeight: isMobile ? "30px" : "65px", // Adjust line height for mobile
          textAlign: "left",
          marginTop: isMobile ? "80px" : "70px", // Adjust margin for mobile
          maxWidth: isMobile ? "100%" : "50%", // Adjust width for mobile
          overflowWrap: "break-word",
        }}
      >
        Aligning Product Strategy with Business Goals
      </Typography>
      <div
        className={`flex flex-col items-start px-8 ${
          isMobile ? "mt-6" : "mt-2"
        }`}
        style={{
          marginRight: isMobile ? "50%" : "40%",
        }}
      >
        <Typography
          style={{
            fontFamily: "Golos Text",
            fontWeight: 400,
            fontSize: "28px",
            color: "#2F2F30",
            textAlign: "left",
            marginTop: "35px",
          }}
        >
          Background
        </Typography>
      </div>
      <div>
        <Typography
          style={{
            fontFamily: "Golos Text",
            fontWeight: 350,
            fontSize: isMobile ? "20px" : "20px",
            color: "#78787A",
            width: isMobile ? "110%" : "741px",
            marginTop: "10px",
            marginLeft: isMobile ? "-2%" : "",
            textAlign: "left",
          }}
        >
          Client B had a non-technical product manager and no structured product
          vision, causing project delays and inconsistent development
          priorities. Without a product strategy, the team struggled to focus on
          essential features and frequently shifted direction.
        </Typography>
      </div>
      <div
        className="flex flex-col items-start mt-2"
        style={{
          marginRight: isMobile ? "16%" : "9%", // Further reduce margin for mobile
          width: isMobile ? "90%" : "40%", // Increase width for mobile
          overflowWrap: "break-word", // Ensure text wraps properly
        }}
      >
        <Typography
          style={{
            fontFamily: "Golos Text",
            fontWeight: 400,
            fontSize: "28px",
            color: "#2F2F30",
            textAlign: "left",
            marginTop: "40px",
          }}
        >
          Challenges
        </Typography>
        <div className="mt-4">
          <Typography
            style={{
              fontFamily: "Golos Text",
              fontWeight: 350,
              fontSize: isMobile ? "20px" : "20px",
              color: "#78787A",
              textAlign: "left",
              width: isMobile ? "45%" : "800px", // Ensure it takes full width
              overflowWrap: "break-word", // Ensure text wraps properly
            }}
          >
            • A lack of structured product vision, leading to misaligned
            priorities.
          </Typography>
          <Typography
            style={{
              fontFamily: "Golos Text",
              fontWeight: 350,
              fontSize: isMobile ? "20px" : "20px",
              color: "#78787A",
              textAlign: "left",
              width: isMobile ? "45%" : "800px", // Ensure it takes full width
              overflowWrap: "break-word", // Ensure text wraps properly
            }}
          >
            • No phased release strategy, resulting in overwhelming work for the
            development team
          </Typography>
          <Typography
            style={{
              fontFamily: "Golos Text",
              fontWeight: 350,
              fontSize: isMobile ? "20px" : "20px",
              color: "#78787A",
              textAlign: "left",
              overflowWrap: "break-word", // Ensure text wraps properly
              width: "800px",
            }}
          >
            • Insufficient alignment between product goals and business
            objectives
          </Typography>
        </div>
      </div>
      {!isMobile && (
        <div className="fixed top-28 left-20 h-1/2 w-64 p-2">
          <Typography
            style={{
              fontFamily: "Golos Text",
              fontSize: "22px",
              fontWeight: 600,
              color: "#2F2F30",
              textAlign: "left",
            }}
          >
            CONTENTS
          </Typography>
          <ul>
            <li>
              <Typography
                align="left"
                style={{
                  marginTop: "8px",
                  fontFamily: "Golos Text",
                  fontSize: "22px",
                  fontWeight: 600,
                  color: "#78787A",
                }}
              >
                Background
              </Typography>
            </li>
            <li>
              <Typography
                align="left"
                style={{
                  marginTop: "8px",
                  fontFamily: "Golos Text",
                  fontSize: "22px",
                  fontWeight: 600,
                  color: "#78787A",
                }}
              >
                Challenges
              </Typography>
            </li>
            <li>
              <Typography
                align="left"
                style={{
                  marginTop: "8px",
                  fontFamily: "Golos Text",
                  fontSize: "22px",
                  fontWeight: 600,
                  color: "#78787A",
                }}
              >
                CPO Solution
              </Typography>
              <li>
                <Typography
                  align="left"
                  style={{
                    marginTop: "8px",
                    fontFamily: "Golos Text",
                    fontSize: "20px",
                    fontWeight: 400,
                    color: "#78787A",
                  }}
                >
                  Defined Product Vision and Timeline
                </Typography>
              </li>
              <li>
                <Typography
                  align="left"
                  style={{
                    marginTop: "8px",
                    fontFamily: "Golos Text",
                    fontSize: "20px",
                    fontWeight: 400,
                    color: "#78787A",
                  }}
                >
                  Phased Release Strategy
                </Typography>
              </li>
              <li>
                <Typography
                  align="left"
                  style={{
                    marginTop: "8px",
                    fontFamily: "Golos Text",
                    fontSize: "20px",
                    fontWeight: 400,
                    color: "#78787A",
                  }}
                >
                  Prioritized Development Based on User Needs
                </Typography>
              </li>
              <li>
                <Typography
                  align="left"
                  style={{
                    marginTop: "8px",
                    fontFamily: "Golos Text",
                    fontSize: "20px",
                    fontWeight: 400,
                    color: "#78787A",
                  }}
                >
                  Regular Checkpoints and Adjustments
                </Typography>
              </li>
            </li>
            <li>
              <Typography
                align="left"
                style={{
                  marginTop: "8px",
                  fontFamily: "Golos Text",
                  fontSize: "22px",
                  fontWeight: 600,
                  color: "#78787A",
                }}
              >
                Impact
              </Typography>
            </li>
          </ul>
        </div>
      )}
      <div
        className="flex flex-col items-start mt-2"
        style={{
          marginRight: isMobile ? "45%" : "9%",
          width: isMobile ? "60%" : "40%",
        }}
      >
        <Typography
          style={{
            fontFamily: "Golos Text",
            fontWeight: 400,
            fontSize: "28px",
            color: "#2F2F30",
            textAlign: "left",
            marginTop: "40px",
          }}
        >
          CPO Solution
        </Typography>
        <Typography
          style={{
            fontFamily: "Golos Text",
            fontWeight: 400,
            fontSize: "22px",
            textAlign: "left",
            marginTop: "10px",
            color: "#78787A",
            width: isMobile ? "170%" : "850px",
          }}
        >
          As the acting CPO for Client B, IDEADOX led the team in a
          comprehensive transformation to boost technical efficiency.
        </Typography>
        <Typography
          style={{
            fontFamily: "Golos Text",
            fontWeight: 400,
            fontSize: "22px",
            color: "#2F2F30",
            textAlign: "left",
            marginTop: "40px",
            width: isMobile ? "170%" : "90%",
          }}
        >
          Defined Product Vision and Timeline
        </Typography>
        <Typography
          style={{
            fontFamily: "Golos Text",
            fontWeight: 400,
            fontSize: isMobile ? "20px" : "20px",
            textAlign: "left",
            marginTop: "10px",
            color: "#78787A",
            width: isMobile ? "185%" : "850px",
          }}
        >
          Developed a structured product vision aligned with Client A's business
          goals, giving the team a clear understanding of the end objective.
          This also helped in breaking down complex tasks into manageable
          segments.
        </Typography>
        <Typography
          style={{
            fontFamily: "Golos Text",
            fontWeight: 400,
            fontSize: "22px",
            color: "#2F2F30",
            textAlign: "left",
            marginTop: "40px",
            width: isMobile ? "170%" : "90%",
          }}
        >
          Phased Release Strategy
        </Typography>
        <Typography
          style={{
            fontFamily: "Golos Text",
            fontWeight: 400,
            fontSize: isMobile ? "20px" : "20px",
            textAlign: "left",
            marginTop: "10px",
            color: "#78787A",
            width: isMobile ? "185%" : "850px",
          }}
        >
          Introduced a phased feature release plan, focusing on prioritizing
          high-impact features in early stages. Each phase was mapped out based
          on realistic development timelines, making progress achievable and
          allowing for gradual testing and adjustments.
        </Typography>
        <Typography
          style={{
            fontFamily: "Golos Text",
            fontWeight: 400,
            fontSize: "22px",
            color: "#2F2F30",
            textAlign: "left",
            marginTop: "40px",
            width: isMobile ? "170%" : "90%",
          }}
        >
          Prioritized Development Based on User Needs
        </Typography>
        <Typography
          style={{
            fontFamily: "Golos Text",
            fontWeight: 400,
            fontSize: isMobile ? "20px" : "20px",
            textAlign: "left",
            marginTop: "10px",
            color: "#78787A",
            width: isMobile ? "185%" : "850px",
          }}
        >
          Collaborated with the product team to define essential user features
          and align development around these priorities. This focused approach
          minimized unnecessary features, allowing the team to deliver
          high-value components more quickly.
        </Typography>
        <Typography
          style={{
            fontFamily: "Golos Text",
            fontWeight: 400,
            fontSize: "22px",
            color: "#2F2F30",
            textAlign: "left",
            marginTop: "40px",
            width: isMobile ? "170%" : "90%",
          }}
        >
          Regular Checkpoints and Adjustments
        </Typography>
        <Typography
          style={{
            fontFamily: "Golos Text",
            fontWeight: 400,
            fontSize: isMobile ? "20px" : "20px",
            textAlign: "left",
            marginTop: "10px",
            color: "#78787A",
            width: isMobile ? "185%" : "850px",
          }}
        >
          Conducted regular reviews of development progress to assess if any
          adjustments were needed. This helped keep the project aligned with
          goals and ensured that any emerging issues were promptly addressed.
        </Typography>
        <Typography
          style={{
            fontFamily: "Golos Text",
            fontWeight: 400,
            fontSize: "28px",
            color: "#2F2F30",
            textAlign: "left",
            marginTop: "40px",
          }}
        >
          Impact
        </Typography>
        <Typography
          style={{
            fontFamily: "Golos Text",
            fontWeight: 400,
            fontSize: isMobile ? "20px" : "20px",
            textAlign: "left",
            marginTop: "10px",
            color: "#78787A",
            width: isMobile ? "185%" : "850px",
          }}
        >
          •{" "}
          <span
            style={{
              color: "#2F2F30",
            }}
          >
            50% increase in product delivery speed
          </span>{" "}
          by streamlining feature releases and focusing on essential functions.
        </Typography>
        <Typography
          style={{
            fontFamily: "Golos Text",
            fontWeight: 400,
            fontSize: isMobile ? "20px" : "20px",
            textAlign: "left",
            marginTop: "10px",
            color: "#78787A",
            width: isMobile ? "185%" : "850px",
          }}
        >
          •{" "}
          <span
            style={{
              color: "#2F2F30",
            }}
          >
            40% reduction in development time per feature
          </span>{" "}
          due to phased planning and manageable timelines.
        </Typography>
        <Typography
          style={{
            fontFamily: "Golos Text",
            fontWeight: 400,
            fontSize: isMobile ? "20px" : "20px",
            textAlign: "left",
            marginTop: "10px",
            color: "#78787A",
            width: isMobile ? "185%" : "850px",
          }}
        >
          •{" "}
          <span
            style={{
              color: "#2F2F30",
            }}
          >
            Greater alignment with business objectives
          </span>{" "}
          enhancing the overall quality and relevance of each release.
        </Typography>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center", // Center horizontally
            marginTop: "60px",
            width: isMobile ? "160%" : "140%", // Ensure it takes full width
          }}
        >
          <img src={Star} alt="Star" style={{ marginRight: "0.5rem" }} />
          <Typography
            style={{
              fontSize: 28,
              fontFamily: "Bricolage Grotesque",
              fontWeight: 200,
              color: "#2F2F30",
            }}
          >
            Case Study
          </Typography>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center", // Center horizontally
            width: "140%", // Ensure it takes full width
          }}
        >
          <Typography
            style={{
              fontFamily: "Golos Text",
              fontSize: isMobile ? "26px" : "34px",
              fontWeight: 600,
              textAlign: "center",
              marginTop: "40px",
              marginLeft: isMobile ? "17%" : "",
            }}
          >
            Read More
          </Typography>
        </div>
        <div
          className="case-studies-list"
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "40px",
            marginTop: "20px",
            flexDirection: isMobile ? "column" : "row", // Change direction for mobile
            alignItems: isMobile ? "center" : "flex-start", // Center items on mobile
            marginLeft: isMobile ? "12%" : "",
          }}
        >
          {displayedCaseStudies.map((study, index) => (
            <div
              key={index}
              style={{
                width: "300px", // Set a consistent width
                padding: "16px",
              }}
            >
              <CaseStudyCard
                title={study.title}
                link={study.link}
                image={study.image}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CaseStudy8;
